import type { ContentHref } from '@generalTypes/apiTypes';
import { selectRawWebPage, selectWebPage } from '@newStore/documentApi/documentApiSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import {
  type AsideChangeMessageSelector,
  type WebTabComponent,
  isWebTabComponent,
} from '@nodeTypeConfig/configTypes';

import { stringDiffArrowFunction } from '../transformProposal/asideDiffText';
import { getFormattedDate } from './selectChangeMessageForDate';

export const selectChangeMessageForWebPageDate: AsideChangeMessageSelector<WebTabComponent> =
  createTypedSelector(
    [
      (state, href: ContentHref) => selectWebPage(state, href),
      (state, href: ContentHref) => selectRawWebPage(state, href),
      (state, href: ContentHref, config: WebTabComponent) => config,
    ],
    (content, originalContent, config): string | null => {
      if (!isWebTabComponent(config)) {
        console.error('Edit config is not for webPage', config);
      }

      if (!config.property) {
        console.error('No property found for config', config);
        throw Error(`Can not convert ${config} property to a string`);
      }

      const newValue = getFormattedDate(content, config.property);
      const oldValue = getFormattedDate(originalContent, config.property);

      const diffHtml = stringDiffArrowFunction(newValue, oldValue);

      return diffHtml;
    },
  );
